import { useEffect } from "react";

import { PaidLandingPersonaTypes } from "@/utils/anchor-queries/get-anchor-contents";
import { AnchorContentsResponse } from "@/utils/anchor-queries/get-anchor-contents";
import { experiments, useExperimentExposure } from "@/utils/experiment";

import { ConfluenceSoftwarePageProps } from "./confluence-software-page";
import { ConfluencePagePaidLpConflAnchor } from "./paid-lp-confl-anchor";
import { getPageId } from "./subAnchors/subAnchor-util.tsx";

export interface ConfluencePageSubAnchorProps
    extends ConfluenceSoftwarePageProps {
    anchorContents?: AnchorContentsResponse | null;
}

export const ConfluenceSoftwarePageVariantPaidLpConfSubAnchors = (
    pageProps: ConfluencePageSubAnchorProps
) => {
    const [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure] =
        useExperimentExposure(experiments.cpapiDeprecationConfExperiment);
    const [exposureSubAnchorFired, fireSubAnchorExposure] =
        useExperimentExposure(experiments.cfind3254LandingPageSubAnchor);

    useEffect(() => {
        if (!exposureSubAnchorFired) {
            fireSubAnchorExposure();
        }
        if (!cpapiDeprecationExposureFired) {
            fireCpapiDeprecationExposure();
        }
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure,
        cpapiDeprecationExposureFired,
        fireCpapiDeprecationExposure
    ]);

    return (
        <ConfluencePagePaidLpConflAnchor
            {...pageProps}
            pageId={getPageId(pageProps.subAnchor)}
            persona={"unknown" as PaidLandingPersonaTypes}
            pageVariant="subAnchor"
            dataProductKey="confluence-PaidLpConflSubAnchor"
        />
    );
};
